import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { TelerecourspnrSharedModule } from '../shared';

import { DragulaModule } from 'ng2-dragula';

import { CommonModule } from '@angular/common';
import { historiqueRoute } from './historique-requete/historique.route';
import { addDocumentRoute } from './add-document/document.route';
import { HistoriqueComponent } from './historique-requete/historique.component';
import { DossierComponent } from './historique-requete/dossier/dossier.component';
import { TimelineComponent } from './historique-requete/timeline/timeline.component';
import { TimelineElementComponent } from './historique-requete/timeline/timeline-element/timeline-element.component';
import { DocumentComponent } from './add-document/document.component';
import { RequeteTitleComponent } from './requete-title/requete-title.component';
import { TooltipsComponent } from './historique-requete/timeline/tooltips/tooltips.component';
import { A11yModule } from '@angular/cdk/a11y';

@NgModule({
    imports: [
        TelerecourspnrSharedModule,
        NgbModule,
        RouterModule.forRoot([historiqueRoute, addDocumentRoute], {
            useHash: true
        }),
        DragulaModule,
        CommonModule,
        A11yModule,
    ],
    declarations: [
        HistoriqueComponent,
        TooltipsComponent,
        DossierComponent,
        TimelineComponent,
        TimelineElementComponent,
        DocumentComponent,
        RequeteTitleComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TelerecourspnrRequeteModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/requete/requete.module.ts